module.exports = new __parcel__URL__("vuln-tab-skeleton.tpl.ab369e98.svg").toString();